export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const statGridStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, 1fr)',
    lg: 'repeat(5, 1fr)',
  },
  gap: '16px',
};

export const statCardStyles = {
  minWidth: 0,
};

export const getBudgetRowStyles = isOverBudget => ({
  backgroundColor: ({ palette }) =>
    isOverBudget ? palette.background.tableHighlight : 'transparent',
});

export const summaryRowStyles = {
  backgroundColor: ({ palette }) => palette.background.secondary,
  fontWeight: 700,
  borderTop: ({ palette }) => `2px solid ${palette.primary.main}`,
};

export const percentCellStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '8px',
};

export const meterTrackStyles = {
  width: '74px',
  height: '6px',
  borderRadius: '999px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  overflow: 'hidden',
  flex: 'none',
};

export const getMeterFillStyles = ({ percent, isOverBudget }) => ({
  display: 'block',
  height: '100%',
  width: `${percent}%`,
  backgroundColor: ({ palette }) => (isOverBudget ? palette.warning.main : palette.primary.main),
});

export const drawReviewPaneStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  padding: '16px',
  borderRadius: ({ shape }) => shape.radius.l,
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderLeft: ({ palette }) => `4px solid ${palette.primary.main}`,
  backgroundColor: ({ palette }) => palette.background.primary,
};

export const drawReviewHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  flexWrap: 'wrap',
};

export const drawReviewMetaStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
};

export const disbursementBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  padding: '14px 16px',
  borderRadius: ({ shape }) => shape.radius.m,
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const disbursementRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
};
